import { authFetch } from "~/services/fetch";
import type { DisconnectMultipleDevicesProps } from "../interfaces/IListDevicesprops";
import type { transferMultipleDevicesProps } from "~/components/ListVehiclesSocket/interfaces/IListVehiclesProps";
import notify from "~/utils/notify";

export interface IFilters {
  readonly field: string;
  readonly operator: string;
  readonly value: string
}

interface IAllDevicesRequest {
  readonly dispatchId: string | number | null;
  readonly targetUrl?: string;
  readonly page?: number;
  readonly limit?: number;
  readonly withoutPagination?: boolean
  readonly filters?: readonly IFilters[]
}

export async function getDevicesByStatus({ page = 0, limit = 9999, filters = [], withoutPagination = true, targetUrl, dispatchId }: IAllDevicesRequest) {
  const { data } = await authFetch({
    url: targetUrl,
    data: {
      dispatch_id: dispatchId,
      without_pagination: withoutPagination,
      filters,
      page,
      limit,
    }
  })

  return data;
}

export async function disconnectMultipleDevices({ deviceIds }: DisconnectMultipleDevicesProps) {
  const response = await authFetch({
    url: '/device/disconnect-multiple',
    method: 'POST',
    data: {
      device_ids: deviceIds
    }
  });

  return response;
}

export async function transferMultipleDevices({ devicesIds, dispatchGroup }: transferMultipleDevicesProps) {
  const response = await authFetch({
    url: '/device/transfer-multiple',
    method: 'POST',
    data: {
      device_ids: devicesIds,
      dispatch_group_id: dispatchGroup,
    }
  })

  return response
}

export async function associateDeviceInDispatch({ deviceId, dispatchId }) {
  const response = await authFetch({
        url: '/dispatch/associate',
        method: 'POST',
        data: {
          dispatch_id: dispatchId,
          device_ids: [deviceId],
        },
  })
  
  return response;
}
